module.exports = __webpack_public_path__ + "img/537.45c035fa.jpg";